import React from 'react';
import Button from '../../../common/Button';
import './style.scss';

const StepZero = () =>{
    return(
        <div className='seggregation_section'>
            <h2 className='seggregation_head'>Welcome back, <span>Tushar Bhattrai</span> </h2>
            <Button width="252px" text="Start" height="64px" /> 
        </div>
    )
}

export default StepZero;